import { useAuth } from "../../hooks/useAuth";
import { Building2, Users, Calendar, Activity, LogOut } from "lucide-react";

const TenantDashboard = () => {
    const { user, tenant, logout } = useAuth();

    const stats = [
        { label: "Total Patients", value: "0", icon: <Users className="h-6 w-6" />, color: "bg-blue-500" },
        { label: "Appointments", value: "0", icon: <Calendar className="h-6 w-6" />, color: "bg-green-500" },
        { label: "Active Doctors", value: "0", icon: <Activity className="h-6 w-6" />, color: "bg-purple-500" },
    ];

    return (
        <div className="space-y-8 p-6 lg:p-10 bg-gray-50 min-h-screen">
            {/* Header bar with Logout */}
            <div className="flex justify-between items-center bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-lg bg-primary-600 flex items-center justify-center text-white font-bold">
                        H
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
                            {tenant?.hospitalName || "Hospital Portal"}
                        </h1>
                        <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">
                            Logged in as: {user?.role}
                        </p>
                    </div>
                </div>

                <button
                    onClick={logout}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200"
                >
                    <LogOut size={16} />
                    <span>Sign Out</span>
                </button>
            </div>

            <div>
                <h1 className="text-3xl font-bold text-gray-900">
                    Welcome back, {user?.name}
                </h1>
                <p className="text-gray-500 mt-2">
                    Access your clinical tools and analytics dashboard.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {stats.map((stat, index) => (
                    <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
                        <div className={`${stat.color} p-3 rounded-lg text-white`}>
                            {stat.icon}
                        </div>
                        <div>
                            <p className="text-sm text-gray-500 font-medium">{stat.label}</p>
                            <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center justify-center text-center space-y-4">
                <div className="h-16 w-16 bg-primary-50 rounded-full flex items-center justify-center">
                    <Building2 className="h-8 w-8 text-primary-600" />
                </div>
                <div>
                    <h2 className="text-xl font-bold text-gray-900">Precision Care Initialized</h2>
                    <p className="text-gray-500 max-w-md mx-auto mt-2">
                        Your hospital infrastructure is ready. You can now start adding doctors and managing patients.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TenantDashboard;
